import { atom, useAtom } from "jotai";

import { nextMaturities } from "#/utils/maturities";

export const maturityAtom = atom<string>(nextMaturities()[0]);

export const useMaturity = () => {
  const [maturity, setMaturity] = useAtom(maturityAtom);

  return {
    maturity,
    setMaturity,
  };
};
